export const WELL_BEING_INIT_PAGE = 1;

export const WELL_BEING_PAGESZ = 9;